export default __webpack_public_path__ + "static/media/img_other2.9b3b74e8.webp";